const APP_PREFIX = process.env.REACT_APP_APP_PREFIX || 'app';

export { APP_PREFIX };
